import request from '@/utils/request'
// ocsp查询

export function setVerify (data) {
  return request({
    url: '/verify/verify',
    method: 'post',
    data
  })
}
export function createVerify (data) {
  return request({
    url: '/verify/real_name/createVerify',
    method: 'post',
    data,
    skipErr: true
  })
}
export function checkVerifyStatus (data) {
  return request({
    url: '/verify/real_name/check_verify_status',
    method: 'post',
    data,
    skipErr: true
  })
}
export function getFaceCode (data) {
  return request({
    url: '/verify/real_name/h5FaceQRCode',
    method: 'post',
    data,
    skipErr: true
  })
}
export function getSmsCode (params) {
  return request({
    url: '/verify/real_name/verification-code',
    method: 'get',
    params,
    skipErr: true
  })
}
export function getBackStep (params) {
  return request({
    url: '/verify/real_name/backStep',
    method: 'get',
    params,
    skipErr: true
  })
}
export function sendSmsCode (params) {
  return request({
    url: '/verify/real_name/verification-code',
    method: 'get',
    params,
    skipErr: true
  })
}
export function getAuthStatus (params) {
  return request({
    url: '/face/qryFaceResult',
    method: 'get',
    params,
    skipErr: true
  })
}
export function getFaceUrl (data) {
  return request({
    url: '/face/h5FaceQRCode',
    method: 'post',
    data,
    skipErr: true
  })
}
export function getInfo (params) {
  return request({
    url: '/verify/real_name/info',
    method: 'get',
    params,
    skipErr: true
  })
}
export function setAuthInfo (data) {
  return request({
    url: '/verify/real_name/set-auth-info',
    method: 'post',
    data,
    skipErr: true
  })
}
export function getPersonFace (data) {
  return request({
    url: '/verify/real_name/h5FaceQRCode',
    method: 'post',
    data,
    skipErr: true
  })
}
export function getLegalPersonInfo (params) {
  return request({
    url: '/verify/real_name/legal_person_info',
    method: 'get',
    params,
    skipErr: true
  })
}
export function getLegalPersonVerify (data) {
  return request({
    url: '/verify/real_name/legal_person_verify',
    method: 'post',
    data,
    skipErr: true
  })
}
export function getLegalPersonAuthMode (data) {
  return request({
    url: '/verify/real_name/change_legal_person_auth_mode',
    method: 'post',
    data,
    skipErr: true
  })
}
export function getRemainAuthTimes (data) {
  return request({
    url: '/verify/real_name/remain_auth_times',
    method: 'post',
    data
  })
}
// 获取银行卡的银行名称
export function getBank (params) {
  return request({
    url: '/verify/real_name/get_bank_branch_list',
    method: 'get',
    params
  })
}
export function setMakeInfo (data) {
  return request({
    url: '/verify/real_name/set_make_money_info',
    method: 'post',
    data,
    skipErr: true
  })
}
// 经办人刷脸认证接口
export function getAgentFace (data) {
  return request({
    url: '/verify/real_name/agent_face_verify',
    method: 'post',
    data,
    skipErr: true
  })
}
// 经办人刷脸认证接口
export function getMakeMoneyVerify (data) {
  return request({
    url: '/verify/real_name/make_money_verify',
    method: 'post',
    data,
    skipErr: true
  })
}
// 对公打款最后期限
export function getMakeMoneyDeadline (params) {
  return request({
    url: '/verify/real_name/make_money_deadline',
    method: 'get',
    params
  })
}
// 办理人信息
export function getAgentInfo (params) {
  return request({
    url: '/verify/real_name/agent_info',
    method: 'get',
    params,
    skipErr: true
  })
}
// 下证
export function getIssue (params) {
  return request({
    url: '/verify/real_name/issue',
    method: 'get',
    params,
    skipErr: true
  })
}